import { render } from "./agent_detail.vue?vue&type=template&id=48683e86"
import script from "./agent_detail.vue?vue&type=script&lang=js"
export * from "./agent_detail.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/uat/ydd-zht-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__